import { useSession } from '@lendi/lala-react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import React, { createContext, useEffect, useState } from 'react';
import uuid from 'uuid';
import { trackingService } from '../../utils/helpers/tracking';
import { CustomerType } from '@lendi/analytics-web';

type LaunchDarklyConsumerContextType = {
  updateLdContext: (extraContext?: Record<string, unknown>) => void;
};

export const LaunchDarklyConsumerContext = createContext<LaunchDarklyConsumerContextType>({
  updateLdContext: () => {},
} as LaunchDarklyConsumerContextType);

const LaunchDarklyConsumerProvider: React.FC = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  if (!localStorage.getItem('ajs_anonymous_id')) {
    localStorage.setItem('ajs_anonymous_id', `"${uuid.v4()}"`);
  }

  const targetId = localStorage.getItem('ajs_anonymous_id') as string;
  const ldClient = useLDClient();
  const { identity, brand } = useSession();

  const updateLdContext = (extraContext = {}) => {
    if (!ldClient) return;

    const custom = { targetId, brand, ...(ldClient.getUser().custom || {}), ...extraContext };
    if (identity) {
      // tslint:disable-next-line: no-floating-promises
      ldClient.identify({ key: identity.id, custom, anonymous: false }, undefined, (_error, flags) => {
        trackingService.identityTracking(identity.id, flags || undefined, {
          type: CustomerType.CUSTOMER,
        });
      });
    } else {
      // tslint:disable-next-line: no-floating-promises
      ldClient.identify({ anonymous: true, custom }, undefined, (_error, flags) => {
        trackingService.identityTracking('', flags || undefined, {
          type: CustomerType.CUSTOMER,
        });
      });
    }
  };

  useEffect(() => {
    updateLdContext();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ldClient, identity]);

  useEffect(() => {
    // If user has adblock and segment event never fires, we need to move the user on
    setTimeout(() => setIsLoading(false), 1500);
  }, []);

  if (isLoading) return null;

  return (
    <LaunchDarklyConsumerContext.Provider value={{ updateLdContext }}>{children}</LaunchDarklyConsumerContext.Provider>
  );
};

export default LaunchDarklyConsumerProvider;
